<template>
  <div
    :ref="`${type}Corousoul`"
    class="ra__carousel"
    :key="getDataProperty(`${type}Key`)"
    v-bind="settings"
  >
    <v-row>
      <template v-for="event in events">
        <v-col cols="12" sm="6" md="4" lg="3" :key="event.id" class="mb-4">
          <v-card outlined class="rounded-lg ra__carousel-card">
            <RaMediaDisplay
              location="primary"
              :media="eventImage(event.attachments)"
              :sizes="sizes"
            />
            <div class="ra__carousel-body">
              <h6 class="ra__carousel-title">{{ event.name }}</h6>
              <p class="ra__carousel-schedule">{{ startDate(event.schedule.start_date_time) }}</p>
              <p v-if="event.event_company_name" class="ra__carousel-schedule">By: {{ event.event_company_name }}</p>
              <div>
                <div class="d-flex justify-space-between align-center">
                  <router-link 
                    :to="{ name: 'public-event-page', params: { eventId: event.id } }" class="ra__carousel-card-schedule">Details
                  </router-link>
                  <v-btn
                    outlined
                    class="btn-outline-primary"
                    @click.stop="openEventQuickModal(event)"
                  >
                  Quick Look
                  </v-btn>
                </div>                      
              </div>
            </div>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </div>
</template>
<script>
import mediaHandler from '~/plugins/media/mediaHandler'
import RaMediaDisplay from '~/components/media/RaMediaDisplay'
import { getDateOnly, getTimeOnly} from '~/plugins/dateTimeHelper'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import size from 'lodash/size'
export default {
  name: 'SearchEventSlider',
  layout: 'default',
  components: { RaMediaDisplay, VueSlickCarousel },
  props: {
    type: {
      type: String,
      default: '',
    },
    events: {
      type: Array,
      default: []
    },
  },
  data(){
    return {
      sizes: '100vw',
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 3,
        touchThreshold: 5,
        autoplay: true,
        autoplaySpeed: 20000,
        arrows: true,
        lazyLoad: 'progressive',
        responsive: [
          {
            breakpoint: 1964,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1264,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '20px',
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      eventsThisMonthKey: 1,
      eventsNextMonthKey: 1,
      futureEventsKey: 1,
      completedEventsKey: 1,
    }
  },
  created () {
    this.$parent.$on('update-carousel-key', (payload) => {
      this[`${payload}Key`] += 1
    })
  },
  methods: {
    eventImage(attachment) {
      return mediaHandler.getAllMediaForModel('Event', attachment)
    },
    startDate (dateTime) {
      return getDateOnly(dateTime)
    },
    startTime (dateTime) {
      return getTimeOnly(dateTime)
    },
    startDateTime(dateTime){
      return `${this.startDate(dateTime)}, ${this.startTime(dateTime)}`
    },
    openEventQuickModal(event){
      this.$root.$emit('open-event-modal', event)
    },
    getDataProperty(fieldName) {
      if (this.$data.hasOwnProperty(fieldName)) {
        return this.$data[fieldName]
      }
      return
    }
  },
}
</script>
